import {
  ISearchingTagApi,
  ISearchingTag,
  TagName,
  TagType,
} from "../../components/tag-searching-input/~types/models/SearchingTag";
import i18n from "../../localization/i18n";

export const extractTagNameFromGroup = (tagGroup: ISearchingTag[]): number =>
  tagGroup[0]?.tagName ?? 0;

export const extractTagOperatorFromGroup = (
  tagGroup: ISearchingTag[]
): number => (tagGroup?.[1]?.value === "=" ? 1 : 0);

export const extractTagValueFromGroup = (tagGroup: ISearchingTag[]): string => {
  switch (tagGroup[0].tagName) {
    case TagName.ChatTag:
      return JSON.stringify({
        Subcategory: tagGroup[0].value,
        Value: tagGroup?.[2]?.value ?? "",
      });
    case TagName.Date:
    case TagName.ChannelName:
    case TagName.Operator:
    case TagName.Contact:
    case TagName.Channel:
    case TagName.ContactExernalId:
    case TagName.Status:
    case TagName.ChatType:
    case TagName.OperatorType:
      return tagGroup?.[2]?.externalValue ?? "";
    default:
      return tagGroup?.[2]?.value ?? "";
  }
};

export const toApiSearchingTags = (tags: ISearchingTag[]) =>
  tags
    .reduce<ISearchingTag[][]>((prev, curr, i) => {
      if (i % 3 === 0) {
        prev.push([curr]);
      } else {
        prev[prev.length - 1].push(curr);
      }
      return prev;
    }, [])
    .filter(
      (tagGroup) =>
        tagGroup?.[0].tagName !== undefined && tagGroup?.[0].tagName !== null
    )
    .map<ISearchingTagApi>((tagGroup) => ({
      Name: extractTagNameFromGroup(tagGroup),
      Operator: extractTagOperatorFromGroup(tagGroup),
      Value: extractTagValueFromGroup(tagGroup),
    }));

export const getTagNameValue = (tagName: any) => {
    switch (tagName) {
        case TagName.Phone:
            return (i18n.t("contact.phoneNumber"));
        case TagName.ChatName:
            return (i18n.t("contact.chatName"));
        case TagName.ContactExernalId:
            return (i18n.t("contact.externalId"));
        case TagName.ContactName:
            return (i18n.t("contact.name"));

        case TagName.Date:
            return (i18n.t("common.date"));
        case TagName.Channel:
            return (i18n.t("common.channelType"));
        case TagName.Operator:
            return (i18n.t("common.operator"));
        case TagName.Contact:
            return (i18n.t("common.contact"));
        case TagName.Status:
            return (i18n.t("common.status"));
        case TagName.Phrase:
            return (i18n.t("common.phrase"));
        case TagName.ChatNumber:
            return (i18n.t("chats.chatNumber"));
        case TagName.MessengerExternalId:
            return (i18n.t("contact.messengerToken"));
        case TagName.ChannelName:
            return (i18n.t("contact.channelName"));
        
        default: return TagName[tagName];
    }
}

export const toSearchingTag = (tags: any[] = []) => {
  return tags?.reduce<ISearchingTag[]>((tags, currentTag) => {
    return [
      ...tags,
      {
        id: 1,
        tagType: TagType.OpeningTag,
        value: getTagNameValue(currentTag.name as TagName),
        tagName: currentTag.name as TagName,
        externalValue: TagName[currentTag.name],
      },
      {
        id: 2,
        tagType: TagType.OperationTag,
        value: (currentTag.operator === 1 ? "=" : "!=") as string,
      },
      {
        id: 3,
        tagType: TagType.ClosingTag,
        tagName: currentTag.name as TagName,
        value: currentTag.value as string,
        externalValue: currentTag.value as string,
      },
    ];
  }, []);
};
